export default __webpack_public_path__ + "static/vpl-logo-04f2dcf07dc9015d2909fd73ba884976.png";